import { Component } from 'react';

import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { flowRight as compose, get } from 'lodash';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';

import Box from '@mui/material/Box';
import AddressHistoryList from '../AddressHistoryList';
import ShipmentHistoryList from '../ShipmentHistoryList';
import styles from './styles';

export default class ShipmentHistoryInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPanel: this.props.isOpen,
      value: 'shipmentHistory',
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  render() {
    const { shipmentHistory = {}, shipment } = this.props;
    return (
      <Box sx={styles.panelContainer}>
        <TabContext value={this.state.value}>
          <TabList onChange={this.handleChange} centered sx={{ '& .MuiTab-root': { fontSize: 12 } }}>
              <Tab label="Shipment History" value="shipmentHistory" />
              <Tab label="Address History" value="addressHistory" />
          </TabList>

          <TabPanel value="shipmentHistory">
            <ShipmentHistoryTab shipment={shipment} shipmentHistory={shipmentHistory} />
          </TabPanel>
          <TabPanel value="addressHistory">
            <AddressHistoryListContainer shipment={shipment} />
          </TabPanel>
        </TabContext>
      </Box>
    );
  }
}

class ShipmentHistoryTab extends Component {
  render() {
    const { shipmentHistory = {}, shipment } = this.props;

    return (
      <Box sx={{ display: 'flex', ...styles.panelContent }}>
        <Box sx={{ flex: 1 }}>
          <ShipmentHistoryList shipment={shipment} shipmentHistory={shipmentHistory} />
        </Box>
      </Box>
    );
  }
}

class AddressHistoryListContainerCompose extends Component {
  componentDidMount() {
    const { messengerStore, shipment } = this.props;
    if (shipment?.dropoff_address) {
      const q = `${get(shipment, 'dropoff_address.street', '')} ${get(shipment, 'dropoff_address.city', '')} ${get(shipment, 'dropoff_address.state', '')} ${get(shipment, 'dropoff_address.zipcode', '')}`;
      messengerStore.addressSearchFilter = {
        from: 0,
        size: 10,
        q: q,
        filters: {},
        sorts: ['-dropoff_earliest_ts'],
      };
      messengerStore.searchAddress();
    }
  }

  render() {
    const { messengerStore } = this.props;
    const { addressSearchResults } = messengerStore;

    return <AddressHistoryList results={addressSearchResults} />;
  }
}
export const AddressHistoryListContainer = compose(withRouter, inject('messengerStore'), observer)(AddressHistoryListContainerCompose);
